import * as React from "react"
import { ImageBlockProps, ImageBlock } from "./image_block"
import { List } from "immutable"

export interface ImagesBlockProps {
  readonly images: List<ImageBlockProps>
}

export const ImagesBlock: React.StatelessComponent<ImagesBlockProps> = p => (
  <section className="block block--image-grid">
    <ul className="row block__list">
      {p.images.map((i, k) => (
        <li className="block__item col-xs-12 col-sm-6 col-md-4" key={`images-${k}`}>
          <ImageBlock {...i} />
        </li>
      ))}
    </ul>
  </section>
)
